export const positionRoute = {
  POSITION_LIST: '/position/list',
  POSITION_DETAIL: '/position/detail/:recordId',
  POSITION_SETTING: '/setting/position'
};
